import { gql } from 'apollo-angular';
/*
 * Participants by rfp (for the seller side)
 */
const GET_RFP_PARTICIPANTS_WITH_RECIPIENT_SPEND_BY_RFP = gql`
  query getRfpParticipants($rfpId: Long) {
    rfp(id: $rfpId) {
      participants {
        participant
        buyer {
          id
          name
          address {
            city
            state
          }
        }
        spend {
          actualSpend
          annualizedActualSpend
        }
        recipientSpend {
          actualSpend
          annualizedActualSpend
          marketShare
          annualizedMarketShare
        }
      }
    }
  }
`;

export default GET_RFP_PARTICIPANTS_WITH_RECIPIENT_SPEND_BY_RFP;